import {css} from 'styled-components';

const SidebarAnimationSpeed = 600;
export default css`
    // --- Card ---
    --mini-card-height: 240px;
    --card-padding: var(--space-lg);
    --card-border-radius: 8px;

    // --- Button ---
    --rounded-btn-size: 15px;
    --hamburger-btn-size: 82px;

    // --- Form ---
    --form-control-height: 36px;

    // --- sidebar ---
    --dialog-width: 400px;
    --sidebar-animation-speed: ${SidebarAnimationSpeed}ms;
    --sidebar-width: 360px;
    --large-sidebar-width: 500px;
    --sidebar-padding: 20px;

    @media only screen and (max-width: 1640px) {
        --sidebar-width: 300px;
    }
    @media only screen and (max-width: 1440px) {
        --sidebar-width: 240px;
        --large-sidebar-width: 300px;
    }
`;

export {SidebarAnimationSpeed};
